<section>
  <h2 class="heading-underline">Images</h2>

  <mat-tab-group [selectedIndex]="toggleState" (selectedTabChange)="onTabChanged($event)" animationDuration="200ms">
    <mat-tab label="URL" [disabled]="disableTab(ToggleState.URL)" title="Use a URL as the image source">
      <ng-template mat-tab-label>
        <mat-icon title="URL">link</mat-icon>
        <span>URL</span>
      </ng-template>
      <ng-template matTabContent>
        <table>
          <tr>
            <td><h2 class="heading-underline">URL</h2></td>
          </tr>
          <tr>
            <td>
              <input
                [(ngModel)]="urlValue.value"
                (ngModelChange)="onSourceChanged(ImageFieldType.URL)"
                placeholder="E.g. https://images.com/myImage.png"
                />
              </td>
            </tr>
            <tr>
              <td>
                <button theme="medium" (click)="onActionClick()" [disabled]="!isValid">
                  {{ mode === Mode.INSERT ? 'INSERT' : 'UPDATE' }}
                </button>
              </td>
            </tr>
          </table>
        </ng-template>
      </mat-tab>
      <mat-tab label="FILE_TYPE" [disabled]="disableTab(ToggleState.FILE_TYPE)" title="Use a file type as the image source">
        <ng-template mat-tab-label>
          <mat-icon title="File type">description</mat-icon>
          <span>File type</span>
        </ng-template>
        <ng-template matTabContent>
          <table>
            <tr>
              <td><h2 class="heading-underline">File type</h2></td>
            </tr>
            <tr>
              <td>
                <mat-select
                  class="full-width"
                  placeholder="Choose a file type..."
                  title="Choose a file type"
                  [(ngModel)]="selectedFileType"
                  (selectionChange)="onSourceChanged(ImageFieldType.FILE_TYPE)"
                  >
                  @for (fileType of fileTypes; track fileType.id) {
                    <mat-option [value]="fileType">
                      {{ fileType.label }}
                    </mat-option>
                  }
                </mat-select>
              </td>
            </tr>
            <tr>
              <td>
                <button theme="medium" (click)="onActionClick()" [disabled]="!isValid">
                  {{ mode === Mode.INSERT ? 'INSERT' : 'UPDATE' }}
                </button>
              </td>
            </tr>
          </table>
        </ng-template>
      </mat-tab>
      <mat-tab label="FIELD" [disabled]="disableTab(ToggleState.FIELD)" title="Use a field as the image source">
        <ng-template mat-tab-label>
          <mat-icon title="Field">text_fields</mat-icon>
          <span>Field</span>
        </ng-template>
        <ng-template matTabContent>
          <table>
            <tr>
              <td colspan="2">
                <h2 class="heading-underline">Field or Script</h2>
              </td>
            </tr>
            <tr>
              <td><h4>Field</h4></td>
              <td>
                <mat-select
                  class="full-width"
                  style="max-width: 86%"
                  placeholder="Choose a field..."
                  title="Choose a field for the image source url"
                  [(ngModel)]="entityFieldValue.value"
                  (ngModelChange)="onEntityFieldChosen()"
                  >
                  @for (field of entityFields; track field.path) {
                    <mat-option [value]="field.path">
                      {{ field.label }}
                    </mat-option>
                  }
                </mat-select>
                <span style="margin-left: 8px">OR</span>
              </td>
            </tr>
            <tr>
              <td><h4>Script</h4></td>
              <td>
                <input [ngModel]="scriptDisplayValue()" (ngModelChange)="onScriptFieldChosen($event)" placeholder="E.g. myUrl" />
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
              <td>
                <button theme="medium" (click)="onActionClick()" [disabled]="!isValid">
                  {{ mode === Mode.INSERT ? 'INSERT' : 'UPDATE' }}
                </button>
              </td>
            </tr>
          </table>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </section>
